<template>
  <v-card class="elevation-8 pt-10 pb-10 pl-5 pr-5" height="500px">
    <v-img height="90" contain src="@/assets/logo.png"> </v-img>
    <v-card-title class="font-weight-black justify-center">
      {{ form_title }}
    </v-card-title>
    <v-card-subtitle class="font-weight-black text-center mt-0"> 系統登入 </v-card-subtitle>

    <v-card-text v-if="is_show_btn === true"> </v-card-text>

    <v-card-text v-if="is_login === false">
      {{ login_text }}
      <v-progress-linear v-if="!is_hide_progress" indeterminate color="primary"></v-progress-linear>
    </v-card-text>

    <v-card-actions v-if="is_show_btn" class="justify-center">
      <v-btn style="text-transform: unset" plain color="#333333" class="pl-10 pr-10" @click="goHome">
        <v-icon left> mdi-open-in-new </v-icon>
        Optimize99
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import { apiSLogin, apiCheckLogin, apiRefreshToken } from '@/api/user.js'
import { apiGetContainers } from '@/api/optimize.js'

export default {
  name: 'UserAuth',
  components: {},
  computed: {
    ...mapGetters(['loggedInfo']),
  },
  created: async function () {
    let that = this
    this.initPage()
    console.log(this.$route)

    // email=watsonlin%40nineder.com&id=6226fb550abb950001c41698

    // if (!this.$route.query.email) {
    //     this.login_text = '身份驗證失敗，請點擊下方連結回Optimize99重新登入'
    //     this.is_show_btn = true
    //     this.is_hide_progress = true
    // 	localStorage.clear()
    //     return
    // }

    // 先看現在的身份是不是同一個email，如果是就refresh，
    const user_info = await this.getUserInfo()
    console.log('user_info', user_info)

    if (user_info && user_info.email === this.$route.query.email) {
      let new_token = await apiRefreshToken()
        .then(function (resp) {
          console.log('refresh_token', resp)
          return resp.data.data
        })
        .catch(function (error) {
          console.log('refresh_token_error', error)
          return false
        })

      if (new_token) {
        localStorage.setItem('authorization_token', new_token)
        this.afterLogin(user_info)
        return
      }
    }

    if (user_info && !this.$route.query.email) {
      let new_token = await apiRefreshToken()
        .then(function (resp) {
          console.log('refresh_token', resp)
          return resp.data.data
        })
        .catch(function (error) {
          console.log('refresh_token_error', error)
          return false
        })

      if (new_token) {
        this.$store.commit('resetState')
        localStorage.setItem('authorization_token', new_token)
        this.afterLogin(user_info)
        return
      }
    }

    this.$store.commit('resetState')
    if (!this.$route.query.email) {
      this.is_hide_progress = true
      this.login_text = '身份驗證失敗，請點擊下方連結回Optimize99重新登入'
      this.is_show_btn = true
      return
    }

    let params = {
      email: this.$route.query.email,
    }

    setTimeout(function () {
      that.signIn(params)
    }, 5000)
  },
  mounted: function () {
    console.log(process.env.VUE_APP_MODE)
    console.log(process.env.VUE_APP_API_ENDPOINT)
  },
  data: function () {
    return {
      // 登入視窗標題
      form_title: '',

      // 登入視窗副標題
      form_subtitle: '',

      is_show_btn: false,

      is_hide_progress: false,

      login_text: '',

      is_login: false,

      go_home_text: '',
    }
  },
  methods: {
    /**
     * 2022/1/2 created by Watson
     *
     * function description:
     * 初始化頁面參數
     *
     * @return {none}
     */
    initPage: function () {
      this.login_text = '身份驗證中'
      this.form_title = 'Optimize99'
      this.form_subtitle = ''
    },
    /**
     * 2022/1/2 created by Watson
     *
     * function description:
     * 登入功能
     *
     * @return {none}
     */
    signIn: async function (params) {
      let that = this
      let result = await apiSLogin(params)
        .then(function (resp) {
          let data = resp.data
          console.log('SLogin', data)

          localStorage.setItem('authorization_token', data.data.token)

          return data.data
        })
        .catch(function (error) {
          console.log(error)

          if (error.includes('303')) {
            that.is_hide_progress = true
            that.login_text = '身份驗證失敗，請點擊下方連結回Optimize99重新登入'
            that.is_show_btn = true
          } else if (error.includes('400')) {
            that.is_hide_progress = true
            that.login_text = '帳號尚未啟用'
            that.is_show_btn = true
          } else {
            that.$root.vtoast.show({
              message: '登入失敗，原因: ' + error,
            })
          }

          return null
        })

      if (result === null) {
        return
      }

      console.log('result', result)
      this.afterLogin(result)
    },
    goHome: function () {
      let required_params = ['email']

      // 回digi99重新登入
      let url = process.env.VUE_APP_HOME_PAGE
      url = new URL(url)
      url.searchParams.set('opt99_redirect_url', 'https://admin.optimize99.com/auth')
      url.searchParams.set('opt99_redirect_params', JSON.stringify(required_params))
      url.searchParams.set('isForceLogout', true)

      const origin_query = new URLSearchParams(this.$route.query)
      if (origin_query.has('line-group-token')) {
        for (const [key, value] of origin_query) {
          url.searchParams.set(key, value)
        }
      }

      window.location.href = url.href
    },
    async getUserInfo() {
      let result = null
      result = await apiCheckLogin()
        .then(function (resp) {
          console.log('resp', resp)
          return resp.data.data
        })
        .catch(function (error) {
          console.log('getUserInfoError', error)
          return null
        })
      return result
    },
    async afterLogin(user_info) {
      this.$root.vtoast.show({
        message: '登入成功！',
        color: 'primary',
      })
      let user_info_container = []
      if (user_info.container_user_enabled && user_info.container_user_enabled.container) {
        user_info.container_user_enabled.container.forEach((container) => {
          user_info_container.push(container.id)
        })
      }
      // vuex 紀錄使用者資料
      const result = user_info
      this.$store.commit('login', result)

      // org對容器的mapper
      let account_organizations = result.organizations
      // console.log('account_organizations', account_organizations)
      // 取所有org對應的container
      let organize_container_mapper = {}

      for (let idx = 0; idx < account_organizations.length; idx++) {
        let account_organization = account_organizations[idx]
        // console.log('account_organization', account_organization)
        let containers = await apiGetContainers(account_organization.org_id)
          .then(function (resp) {
            let data = resp.data.data
            console.log('containers', data)
            return data
          })
          .catch(function (error) {
            console.log('取得容器失敗，原因: ' + error)
            // that.$root.vtoast.show({ message: "取得組織容器失敗，原因: " + (error.response ? error.response.data : error) })
            return []
          })
        // beta user什麼都看得到
        if (!user_info.is_beta_user) {
          // 如果有找到，代表有限制過可看到的容器，沒有找到預設就是全開
          let is_container_user = false
          if (user_info.container_user_enabled) {
            is_container_user = user_info.container_user_enabled.enabled_status.find((enabled_status) => {
              return enabled_status.userAuthId.orgId === account_organization.org_id && enabled_status.enable
            })
          }
          console.log('is_container_user', is_container_user)
          if (is_container_user) {
            containers = containers.filter((container) => {
              return user_info_container.includes(container.id)
            })
          }
        }
        console.log('filter_container', containers)
        organize_container_mapper[account_organization.org_id] = {
          organization: account_organization,
          containers: containers,
        }
      }

      console.log('organize_container_mapper', organize_container_mapper)

      // 沒有組織的話進不去！
      if (Object.keys(organize_container_mapper).length === 0) {
        this.$root.vtoast.show({
          message: '您的帳號無所屬任何組織，請先加入組織',
        })
        return
      }

      this.$store.commit('update_organize_container_mapper', organize_container_mapper)

      console.log(organize_container_mapper)

      let to_org_id = ''
      if (result.default_value) {
        if (result.default_value.last_seen_org && organize_container_mapper[result.default_value.last_seen_org]) {
          to_org_id = result.default_value.last_seen_org
        }
      }
      if (!to_org_id) {
        to_org_id = Object.keys(organize_container_mapper)[0]
      }
      let to_container_id = ''
      let match_container = []
      if (result.default_value && result.default_value.last_seen_container_id) {
        match_container = organize_container_mapper[to_org_id].containers.filter(function (container) {
          return container.id === result.default_value.last_seen_container_id
        })

        if (match_container.length !== 0) {
          to_container_id = match_container[0].id
        } else {
          if (organize_container_mapper[to_org_id].containers[0]) {
            to_container_id = organize_container_mapper[to_org_id].containers[0].id
          }
        }
      } else {
        if (organize_container_mapper[to_org_id].containers[0]) {
          to_container_id = organize_container_mapper[to_org_id].containers[0].id
        }
      }

      this.$store.commit('select_organize', organize_container_mapper[to_org_id].organization)
      if (to_container_id) {
        this.$store.commit('selected_container', match_container[0])

        if (this.$route.query['line-group-token']) {
          const query = new URLSearchParams(this.$route.query)
          this.$router.push(`/${to_org_id}/${to_container_id}/home?${query}`)
        } else {
          this.$router.push(`/${to_org_id}/${to_container_id}/home`)
        }
      } else {
        this.$router.push(`/${to_org_id}/home`)
      }
    },
  },
}
</script>
<style scoped>
.clickable {
  cursor: pointer;
}
</style>
